$('#selectCustomer').on('change', function () {
    let url = '/admin/setCustomer/' + $(this).val();

    $.ajax({
        url: url,
        method: 'POST',
        cache: false,
        processData: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        complete: function (result) {
        },
        error: function (result) {
            alert("Es ist ein Fehler beim Wechsel des Kunden aufgetreten!");
        },
        success: function (result) {
                if (result.hasOwnProperty('redirect')) {
                   document.location.href = result.redirect;
               }
        }
    });
});
